import { render, staticRenderFns } from "./Cotacao.vue?vue&type=template&id=7bc4115b&scoped=true&"
import script from "./Cotacao.vue?vue&type=script&lang=js&"
export * from "./Cotacao.vue?vue&type=script&lang=js&"
import style0 from "./Cotacao.vue?vue&type=style&index=0&id=7bc4115b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc4115b",
  null
  
)

export default component.exports